import { useEffect, useState } from "react";
import Pagination from "src/components/Pagination";

const OffersSelect = (props) => {
  const pagination = props.pagination;
  const currentPage = props.currentPage ?? 1;
  const onPageChange = props.onPageChange;
  const [type, setType] = useState("All");
  const [allOffers, setAllOffers] = useState([]);
  const [matchingTagOffers, setMatchingTagOffers] = useState([]);
  const [offerList, setOfferList] = useState([]);

  // Pending selection: only committed when "Select" is clicked; "Back" discards it
  const [pendingItem, setPendingItem] = useState(props.selectedItem);
  useEffect(() => {
    setPendingItem(props.selectedItem);
  }, [props.selectedItem]);

  useEffect(() => {
    const nextAllOffers = props.list || [];
    const normalizedListTagIds = (props.listTagIds || [])
      .map((tag) => (typeof tag === "object" ? tag?._id : tag))
      .filter(Boolean);

    let nextMatchingTagOffers = nextAllOffers;
    if (normalizedListTagIds.length > 0) {
      nextMatchingTagOffers = nextAllOffers.filter(
        (offer) =>
          offer.tag_ids?.length !== 0 &&
          offer.tag_ids?.some((tagId) =>
            normalizedListTagIds.includes(
              typeof tagId === "object" ? tagId?._id : tagId
            )
          )
      );
    }

    setAllOffers(nextAllOffers);
    setMatchingTagOffers(nextMatchingTagOffers);
    setOfferList(type === "All" ? nextAllOffers : nextMatchingTagOffers);
  }, [props.list, props.listTagIds, type]);

  const handleSelectConfirm = () => {
    if (pendingItem != null) {
      props.setSelectedItem(pendingItem);
    }
    props.close();
  };

  const handleType = (type) => {
    setType(type);
  };

  return (
    <div className="NewStrategyModalOverlay">
      <div className="NewScheduleChooseDayModal">
        <div className={"w-full flex justify-between"}>
          <div className={"NewStrategy"}>
            <img
              alt={"Logo"}
              src={props.titleImg}
              className={"w-[18px] h-[18px]"}
            />
            {props.title}
          </div>
          <button className={"CloseIconButton"} onClick={props.close}>
            <img
              alt={"Logo"}
              src={"/media/icons/closeIcon.svg"}
              className={"w-5 h-5"}
            />
          </button>
        </div>
        <div className={"flex flex-col gap-4 w-full"}>
          <div className={"HorizontalDivider"}></div>
          <div className={"NewListTypeButtons"}>
            <button
              onClick={() => handleType("All")}
              className={
                type === "All" ? "NewListChosenButton" : "NewListButton"
              }
            >
              All Offers ({allOffers?.length})
              {type === "All" && (
                <span className={"ChosenMarkerListType"}></span>
              )}
            </button>
            <img
              alt={"Logo"}
              src={"/media/icons/separate.png"}
              className={"h-[22px] w-[1px]"}
            />
            <button
              onClick={() => handleType("Manual")}
              className={
                type === "Manual" ? "NewListChosenButton" : "NewListButton"
              }
            >
              Matching Tags ({matchingTagOffers?.length})
              {type === "Manual" && (
                <span className={"ChosenMarkerListType"}></span>
              )}
            </button>
          </div>
        </div>
        <div className="relative flex items-center w-full">
          <span className="absolute left-3">
            <img
              alt={"Logo"}
              src={"/media/icons/searchIcon.svg"}
              className={"h-[17px] w-[17px]"}
            />
          </span>
          <input
            type="text"
            placeholder="Search"
            value={props.search}
            className="pl-10 pr-4 py-2 border border-gray-300 rounded-lg outline-none w-full h-9 text-[12px]"
            onChange={(e) => props.setSearch(e.target.value)}
          />
        </div>
        <div
          className={
            "w-full flex flex-col gap-2 max-h-[770px] overflow-y-auto overflow-x-hidden min-w-0"
          }
        >
          {offerList?.map((item) => (
            <div
              className={"flex flex-col gap-2 w-full min-w-0"}
              key={item._id}
            >
              <button
                className={"ToggleButtonLine min-w-0"}
                onClick={() => setPendingItem(item)}
              >
                <div className={"flex gap-[6px] items-center min-w-0 flex-1"}>
                  <img
                    alt={"Logo"}
                    src={
                      props.playImg && props.pauseImg && item?.is_enabled
                        ? props.pauseImg
                        : props.playImg && props.pauseImg && !item?.is_enabled
                        ? props.playImg
                        : props.img
                    }
                    className={"w-[14px] h-[14px] flex-shrink-0"}
                  />
                  {props.everflow ? (
                    <div
                      className={"flex flex-col gap-[6px] items-start min-w-0"}
                    >
                      <div className="text-[#15151F] font-['Inter'] text-xs font-semibold leading-[14px]">
                        {item.name}
                      </div>
                      <div className="text-[#8185A8] font-['Inter'] text-xs font-normal leading-[14px]">
                        {item.network_offer_id || item.id}
                      </div>
                    </div>
                  ) : (
                    <div className={"truncate min-w-0"} title={item.name}>
                      {item.name}
                    </div>
                  )}
                </div>
                {item._id === pendingItem?._id ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <rect
                      x="0.5"
                      y="0.5"
                      width="15"
                      height="15"
                      rx="7.5"
                      fill="#F9F5FF"
                    />
                    <rect
                      x="0.5"
                      y="0.5"
                      width="15"
                      height="15"
                      rx="7.5"
                      stroke="#7F56D9"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="8"
                      height="8"
                      rx="4"
                      fill="#7E50EA"
                    />
                  </svg>
                ) : (
                  <div className={"Toggle"}></div>
                )}
              </button>
              <div className={"HorizontalDivider"}></div>
            </div>
          ))}
        </div>
        {props.everflow && pagination && pagination.totalPages > 1 && (
          <div className="w-full">
            <Pagination
              currentPage={currentPage}
              totalPages={pagination.totalPages}
              onPageChange={onPageChange}
              padding="0"
              popup={true}
            />
          </div>
        )}
        {props.everflow && <div className="HorizontalDivider"></div>}
        <div className="flex justify-between items-center w-full">
          <button className={"SecondaryButton"} onClick={props.close}>
            <img
              alt={"Logo"}
              src={"/media/icons/arrowLeft.svg"}
              className={"w-4 h-4"}
            />
            Back
          </button>
          <button
            type="submit"
            className="CreateButton"
            onClick={handleSelectConfirm}
          >
            Select
          </button>
        </div>
      </div>
    </div>
  );
};

export default OffersSelect;
